var DialogSegmentsModule = /** @class */ (function () {
    function DialogSegmentsModule() {
    }
    return DialogSegmentsModule;
}());
export { DialogSegmentsModule };
